import React, { useState } from 'react'

import { LoadingMask } from '@elo-kit/components/loading-mask/LoadingMask'
import { EloButton } from '@elo-kit/components/elo-button/EloButton'
import { TextField } from '@elo-kit/components/elo-ui/text-field/TextField'

import { EMAIL_REGEX } from '@elo-kit/constants/regex.constants'

import { notify } from 'libs/common/notify'
import { useShopStores } from 'shop/hooks/use-store'

import { AuthForm } from './AuthForm'
import { sendConfirmation } from '../../../js/containers/app/api/session.api'

interface ConfirmationNewPageProps {
  historyPush?: (link: string) => void
  LinkComponent?: React.FC<{
    to: string
    children: React.ReactNode
    onClick?: () => void
    className?: string
  }>
}

const ConfirmationNew: React.FC<ConfirmationNewPageProps> = ({ LinkComponent, historyPush }) => {
  const { sellerStore } = useShopStores()
  const { username: sellerUsername } = sellerStore.item
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const emailInvalid = !EMAIL_REGEX.test(email)

  const handleSubmit = async () => {
    setLoading(true)

    const resp = await sendConfirmation({
      email,
      sellerUsername,
    })

    if (resp.success) {
      notify('success', I18n.t('react.shop.auth.confirmation.send'))
      historyPush(`/s/${sellerUsername}/sign_in`)
    }

    setLoading(false)
  }

  return (
    <div className='shop-auth'>
      <div className='fields-container--center-align'>
        <div className='auth-form__container'>
          <AuthForm
            title={I18n.t('react.shop.auth.confirmation.title')}
            description={I18n.t('react.shop.auth.confirmation.description')}
            link={`/s/${sellerUsername}/sign_in`}
            linkTitle={I18n.t('react.shop.auth.sign_in.back')}
            LinkComponent={LinkComponent}
          >
            <div className='fields-container--center-align'>
              <TextField
                placeholder={I18n.t('react.shop.form.email')}
                className='
                  auth-input
                  auth-field
                  fields-container--60-percentage
                  auth-field--with-margins
                  fields-container--mobile-100
                '
                onChange={setEmail}
                isInvalid={emailInvalid}
                value={email}
                errorMessage={I18n.t('react.shared.validations.invalid_email')}
                prefix={<i className='fas fa-envelope prefix-icon' />}
                prefixNormalField
                required
              />
            </div>
            <div className='elo-btn-container elo-btn-container--centered'>
              <EloButton
                className='auth-btn auth-form__btn fields-container--60-percentage'
                disabled={emailInvalid}
                onClick={handleSubmit}
                orange
              >
                {I18n.t('react.shop.auth.confirmation.submit')}
              </EloButton>
            </div>
          </AuthForm>
        </div>
      </div>
      {loading && <LoadingMask />}
    </div>
  )
}
export default ConfirmationNew
